/**
 * Created by Tiger on 24/02/2022.
 */

export const HEADER_TABS = {
  main: 'main', privatisation: 'privatisation',
};

const Types = {
  LANGUAGE: 'LANGUAGE',
  CHANGED_HEADER_TAB: 'CHANGED_HEADER_TAB',

  REFRESH_CONFIG_LIST: 'REFRESH_CONFIG_LIST',
  REFRESH_CONFIG_LIST_SUCCESS: 'REFRESH_CONFIG_LIST_SUCCESS',
  REFRESH_CONFIG_LIST_FAIL: 'REFRESH_CONFIG_LIST_FAIL',

  REFRESH_ALI_HOST_LIST: 'REFRESH_ALI_HOST_LIST',
  REFRESH_ALI_HOST_LIST_SUCCESS: 'REFRESH_ALI_HOST_LIST_SUCCESS',
  REFRESH_ALI_HOST_LIST_FAIL: 'REFRESH_ALI_HOST_LIST_FAIL',

  EDIT_CONFIG: 'EDIT_CONFIG',
  EDIT_CONFIG_SUCCESS: 'EDIT_CONFIG_SUCCESS',
  EDIT_CONFIG_FAIL: 'EDIT_CONFIG_FAIL',

  REFRESH_PRODUCT_LIST: 'REFRESH_PRODUCT_LIST',
  REFRESH_PRODUCT_LIST_SUCCESS: 'REFRESH_PRODUCT_LIST_SUCCESS',
  REFRESH_PRODUCT_LIST_FAIL: 'REFRESH_PRODUCT_LIST_FAIL',

  REFRESH_DEVICE_LIST: 'REFRESH_DEVICE_LIST',
  REFRESH_DEVICE_LIST_SUCCESS: 'REFRESH_DEVICE_LIST_SUCCESS',
  REFRESH_DEVICE_LIST_FAIL: 'REFRESH_DEVICE_LIST_FAIL',

  REFRESH_NOT_PRIVATE_LIST: 'REFRESH_NOT_PRIVATE_LIST',
  REFRESH_NOT_PRIVATE_LIST_SUCCESS: 'REFRESH_NOT_PRIVATE_LIST_SUCCESS',
  REFRESH_NOT_PRIVATE_LIST_FAIL: 'REFRESH_NOT_PRIVATE_LIST_FAIL',

  UPDATE_DEVICES: 'UPDATE_DEVICE',
  UPDATE_DEVICES_SUCCESS: 'UPDATE_DEVICES_SUCCESS',
  UPDATE_DEVICES_FAIL: 'UPDATE_DEVICES_FAIL',
};

export default Types;